import defaultAvatar from '@/assets/images/default-avatar.png';
import searchIcon from '@/assets/images/search-icon.webp';
import { VideoPlayer } from '@/pages/Workbench/components/VideoPlayer';
import { signOut } from '@/services/user';
import { SingleEventSource, redirectToSignIn } from '@/utils';
import { useVisibilityState } from '@ai-indeed/hooks';
import type { HeaderProps } from '@ant-design/pro-components';
import { useModal } from '@ebay/nice-modal-react';
import { NavLink, useLocation, useModel, useMutation } from '@umijs/max';
import { App, Badge, Button, Dropdown, message } from 'antd';
import classNames from 'classnames';
import Cookies from 'js-cookie';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { IconFont } from '../IconFont';

// 该组件拿不到 useApp 的内容，所以使用静态 message
// const { useApp } = App;

export const Header: FC<
  Parameters<NonUndefined<NonFalse<HeaderProps['menuRender']>>>[0]
> = () => {
  // state
  const [messageCount, setMessageCount] = useState(0);
  // initial state
  const { initialState } = useModel('@@initialState');
  // visibilityState
  const visibilityState = useVisibilityState();
  // location
  const { pathname } = useLocation();
  // modal
  const { show } = useModal(VideoPlayer);
  // mutation
  const { mutate: logout } = useMutation<IRes<boolean>, Error>(signOut, {
    onSuccess(res) {
      if (res.code === 0) {
        Cookies.remove(TOKEN_NAME, {
          path: '',
          domain: '.' + window.location.hostname,
        });
        redirectToSignIn();
      }
    },
  });
  // constants
  const hasUserCenterPermission = initialState?.menus.some(
    (menu) => menu.url === '/user-center',
  );
  // methods
  const toUserCenter = () => {
    if (!hasUserCenterPermission) {
      return;
    }
    const token = Cookies.get(TOKEN_NAME);
    window.open(`${location.protocol}//${location.host}/admin?token=${token}`);
  };
  // effect
  useEffect(() => {
    if (pathname === SIGN_IN_PATH || visibilityState === 'hidden') {
      return;
    }
    const eventSource = SingleEventSource.create('/v4/supertext-java/sse', {
      withCredentials: true,
    });
    const onMessageCountChange = (e: MessageEvent<string>) => {
      const { message_count } = JSON.parse(e.data) as { message_count: number };
      setMessageCount(message_count);
    };
    eventSource.addEventListener('message_count', onMessageCountChange);
    return () => {
      eventSource.removeEventListener('message_count', onMessageCountChange);
      eventSource.destroy();
    };
  }, [visibilityState]);

  return (
    <>
      {/* <button
        type="button"
        title="智能搜索"
        className={`
          box-border flex items-center w-88 h-9 px-10
          border-2 border-transparent rounded-full
          text-sm text-secondary-3 transition cursor-pointer
          hover:border-primary
        `}
        style={{
          background: `url("${searchIcon}") #EFF1F6`,
          backgroundRepeat: 'no-repeat, no-repeat',
          backgroundPosition: '12px, center',
          backgroundSize: `20px, contain`,
        }}
        onClick={() => message.info('内测中，即将发布')}
      >
        开启智能搜索
      </button> */}
      <div />
      <div className="flex gap-2.5 items-center">
        {/* <Button
          className="flex justify-center items-center"
          type="text"
          shape="circle"
          title="宣传视频"
          icon={<IconFont type="icon-video_fill_light" className="!text-xl" />}
          onClick={() => show()}
        /> */}
        <NavLink to="/message-center">
          {({ isActive }) => (
            <Badge size="small" count={messageCount} offset={[-8, 8]}>
              <Button
                type="text"
                shape="circle"
                title="消息中心"
                className={classNames({ '!text-primary': isActive })}
                icon={<IconFont type="icon-xiaoxi" className="!text-base" />}
              />
            </Badge>
          )}
        </NavLink>
        {/* <Button
          disabled
          type="text"
          shape="circle"
          title="内测中，即将发布"
          icon={<IconFont type="icon-bangzhu" className="!text-base" />}
        /> */}
        <div className="inline-flex gap-2 items-center">
          <img
            className="size-9 rounded-half transition hover:scale-105"
            src={
              initialState && initialState.userInfo.avatar
                ? initialState.userInfo.avatar
                : defaultAvatar
            }
            alt="user avatar"
          />
          <Dropdown
            placement="bottom"
            arrow={{ pointAtCenter: true }}
            menu={{
              items: [
                {
                  key: 'userCenter',
                  disabled: !hasUserCenterPermission,
                  icon: <IconFont className="!text-sm" type="icon-yonghu" />,
                  label: '用户管理',
                },
                {
                  key: 'logout',
                  icon: <IconFont className="!text-sm" type="icon-tuichu" />,
                  label: '退出登录',
                },
              ],
              onClick: ({ key }) => {
                switch (key) {
                  case 'userCenter': {
                    toUserCenter();
                    break;
                  }
                  case 'logout': {
                    logout();
                    break;
                  }
                }
              },
            }}
          >
            <Button
              className="px-1.5 text-sm text-main"
              type="text"
              iconPosition="end"
              icon={
                <IconFont className="text-secondary-2" type="icon-xiangxia" />
              }
            >
              {initialState ? initialState.userInfo.nickname : '匿名用户'}
            </Button>
          </Dropdown>
        </div>
      </div>
    </>
  );
};
